import React, { Component, useMemo, useEffect, useState } from "react";
import _ from "lodash";
import { useLocation } from "react-router";

function DataTable({ data }) {
  const [table, settable] = useState();
  const location = useLocation();

  useEffect(() => {
    (async () => {
      console.log("    data : ", data);
      let dataList = [];
      if (!_.isNull(data) && !_.isNull(data.data) && data?.data?.length > 0) dataList = data.data;
      let sum = 0;
      let count = 0;
      // ساخت جدول
      let str =
        "<table class='table table-striped text-center table-scrollable fixed-table-header' style='height: 400px; table-layout: fixed!important'>";
      str += "<thead style = 'background:#e2e6ec;' >";
      str += "<tr>";
      str += "<th style='width: 80px '>ردیف</th>";
      str += "<th style='width: 100px '>شماره سفارش</th>";
      str += "<th style='width: 80px '>شماره بلیط </th>";
      str += "<th style='width: 100px '>نام </th>";
      str += "<th style='width: 100px '>موبایل </th>";
      str += "<th style='width: 100px '>شهر </th>";
      str += "<th style='width: 80px'> تفریح </th>";
      str += "<th style='width: 120px'>آیتم</th>";
      str += "<th style='width: 100px'>مبلغ </th>";
      str += "<th style='width: 90px'>تاریخ تفریح</th>";
      str += "<th style='width: 120px'>تاریخ ثبت سفارش </th>";
      str += "<th style='width: 110px'> وضعیت کنسلی </th>";
      str += "<th style='width: 90px'> وضعیت ایتم </th>";
      if (location.pathname.includes("reportBuyTransaction"))
        str += "<th style='width: 80px'> تامین کننده</th>";
      str += "<th style='width: 100px'>زمان خرید</th>";
      if (location.pathname.includes("reportBuyTransaction"))
        str += "<th style='width: 100px'>تاریخ پرداخت به تامین کننده</th>";
      str += "<th style='width: 90px'>مبلغ تراکنش</th>";
      str += "<th style='width: 100px'>نوع تراکنش</th>";
      str += "<th style='width: 100px'>شماره کیف پول </th>";
      str += "<th style='width: 100px'>شماره تراکنش</th>";
      str += "<th style='width: 300px'>توضیحات </th>";
      str += "</tr>";
      str += "</thead > ";
      str += "<tbody>";

      dataList.forEach((item) => {
        let rowspan = item.transactionList.length > 0 ? item.transactionList.length : 1;
        count += 1;
        sum += item.sumAmount;
        str += "<tr>";
        str += "<td rowspan='" + rowspan + "'>" + count + "</td>";
        str += "<td rowspan='" + rowspan + "'>" + item.basketId + "</td>";
        str += "<td rowspan='" + rowspan + "'>" + item.basketItemPersonId + "</td>";
        str += "<td rowspan='" + rowspan + "'>" + item.userFullName + "</td>";
        str += "<td rowspan='" + rowspan + "'>" + item.mobile + "</td>";
        str += "<td rowspan='" + rowspan + "'>" + item.amusementServiceRegionsList?.map(item => item?.region?.name).join(", ") + "</td>";
        str += "<td rowspan='" + rowspan + "'>" + item.basketItemAmusementServiceName + "</td>";
        str += "<td rowspan='" + rowspan + "'>" + (item.eventTitle ? item.eventTitle : (item.amusementServiceReserveItemTitle +
          " - " +
          item.amusementServiceReserveItemGroupTitle)) + "</td>";
        str += "<td rowspan='" + rowspan + "'>" + Number(item.sumAmount).toLocaleString() + "</td>";
        str += "<td rowspan='" + rowspan + "'>" + item.basketItemCheckInDate + "</td>";
        str +=
          "<td rowspan='" +
          rowspan +
          "'>" +
          (item.basketCreated && item.basketCreated.length > 2 ? item.basketCreated : "-") +
          "</td>";
        str += "<td rowspan='" + rowspan + "'>" + item.cancelStatus + "</td>";
        str += "<td rowspan='" + rowspan + "'>" + item.currentStatus + "</td>";

        for (var i = 0; i < item.transactionList.length; i++) {
          if (i > 0) str += "<tr>";
          if (location.pathname.includes("reportBuyTransaction"))
            str += "<td >" + item.transactionList[i].supplierName + "</td>";
          str +=
            "<td >" + item.transactionList[i].completionDate + " " + item.transactionList[i].completionTime + "</td>";
          if (location.pathname.includes("reportBuyTransaction"))
            str +=
              "<td >" + item.transactionList[i].transactionCreated + "</td>";
          str += "<td >" + Number(item.transactionList[i].amount).toLocaleString() + "</td>";

          str += "<td >" + item.transactionList[i].type + "</td>";
          str += "<td >" + item.transactionList[i].userWalletId + "</td>";
          str += "<td >" + item.transactionList[i].id + "</td>";
          str += "<td >" + item.transactionList[i].description + "</td>";

          if (i > 0) str += "</tr>";
        }
        if (item.transactionList.length <= 0) {
          str += "<td > - </td>";
          str += "<td > - </td>";
          str += "<td > - </td>";
          str += "<td > - </td>";
          str += "<td > - </td>";
          str += "<td > - </td>";
          str += "<td > - </td>";
          str += "<td > - </td>";
          str += "<td > - </td>";
          str += "<td > - </td>";
          str += "<td > - </td>";
          str += "<td > - </td>";
        }
        str += "</tr>";
      });
      //- نمایش جمع ایتم ها
      str += "<tr class='bgGray'>";
      str += "<td colspan='2'>" + "تعداد ایتم : " + "</td>";
      str += "<td colspan='3'>" + dataList.length + "</td>";
      str += "<td colspan='2'>" + "جمع مبالغ : " + "</td>";
      str += "<td colspan='3'>" + Number(sum).toLocaleString() + "</td>";
      str += "<td colspan='12'>" + "" + "</td>";
      str += "</tr>";
      //------------
      str += " </tbody >";
      str += " </table > ";
      settable(str);
    })();
    return () => { };
  }, [data]);

  return (
    <div id="root">
      <div
        className="table-scrollable tableFixHead"
        style={{ overflow: "scroll" }}
        dangerouslySetInnerHTML={{ __html: table }}
      ></div>
    </div>
  );
}

export default DataTable;
